"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = void 0;
var util_1 = require("./util");
var range = function (tuple, steps) {
    var _a = util_1.minMax(tuple), min = _a[0], max = _a[1];
    var interval = (max - min) / steps;
    var length = (max - min) / interval + 1;
    var _range = Array.from({ length: length }, function (_, i) {
        return parseFloat((min + i * interval).toFixed(6));
    });
    return tuple[0] === min ? _range : _range.reverse();
};
/**
 * Calculates a path of in-between coordinates between two given coordinates.
 *
 * @param fromCoord google.maps.LatLngLiteral
 * @param toCoord google.maps.LatLngLiteral
 * @returns google.maps.LatLngLiteral[]
 */
var path = function (fromCoord, toCoord) {
    var maxDistance = Math.max(Math.abs(fromCoord.lat - toCoord.lat), Math.abs(fromCoord.lng - toCoord.lng));
    var steps = Math.round(util_1.remap(maxDistance, { min: 0, max: 360 }, { min: 0, max: 10 }));
    if (steps === 0) {
        return [fromCoord, toCoord];
    }
    var latRange = range([fromCoord.lat, toCoord.lat], steps);
    var lngRange = range([fromCoord.lng, toCoord.lng], steps);
    var coords = latRange.map(function (lat, i) { return ({ lat: lat, lng: lngRange[i] }); });
    return coords;
};
exports.path = path;
